/**
 * Cosul Ideal Beauty: costul de procesare si serviciile optionale, in tema.
 * Inlocuieste aplicatia nat-customfee-prover.
 *
 * Diferente fata de aplicatie, toate intentionate:
 *  - nu inlocuieste window.fetch, deci nu strica adaugarile facute de alte
 *    aplicatii si nu pierde `properties` sau `selling_plan` de pe formulare
 *  - nu asculta toate modificarile din pagina, ci doar evenimentul de cos al
 *    temei, deci nu mai bombardeaza /cart.js
 *  - pretul afisat e citit din cos, nu scris de mana in cod
 *  - taxa se cere separat, nu in aceeasi cerere cu produsul, ca o eventuala
 *    indisponibilitate sa nu blocheze adaugarea in cos
 */
(function () {
  'use strict';

  var ACK_KEY = 'ct_fee_ack';
  var busy = false;
  var busySince = 0;
  var lastFeeTry = 0;

  /**
   * Daca o operatie ramane agatata (retea moarta, re-randare care nu se mai
   * termina), `busy` ar bloca pentru totdeauna readaugarea costului.
   * Dupa 12 secunde consideram operatia pierduta si mergem mai departe.
   */
  function locked() {
    if (!busy) return false;
    if (Date.now() - busySince > 12000) { busy = false; return false; }
    return true;
  }

  function lock() { busy = true; busySince = Date.now(); }
  var feeFails = 0;
  var ackSynced = false;

  /**
   * Widgetul de fidelitate sta in iframe si nu se lasa ascuns doar din CSS,
   * asa ca il ascundem direct pe element cat timp sertarul e deschis.
   */
  function toggleFloating(hide) {
    ['#smile-ui-lite-container', '#smile-ui-container', '#tidio-chat',
     '#helpy-social-bar', '#scroll-to-top-button'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.style.setProperty('display', hide ? 'none' : '', 'important');
    });
  }

  function root() {
    return document.querySelector('[data-ct-extras]');
  }

  /**
   * Tema randeaza sertarul si pagina de cos in acelasi document, deci blocul
   * poate exista de mai multe ori. Starea se aplica pe toate, nu doar pe primul.
   */
  function allNodes() {
    return Array.prototype.map.call(
      document.querySelectorAll('[data-ct-extras]'),
      function (r) {
        return {
          root: r,
          upsell: r.querySelector('[data-ct-upsell]'),
          fee: r.querySelector('[data-ct-fee]'),
          addons: Array.prototype.slice.call(r.querySelectorAll('[data-ct-addon]'))
        };
      }
    );
  }

  function nodes() {
    return allNodes()[0] || null;
  }

  function serviceVariantIds(n) {
    var ids = [];
    if (n.fee) ids.push(n.fee.getAttribute('data-variant'));
    n.addons.forEach(function (el) { ids.push(el.getAttribute('data-variant')); });
    return ids;
  }

  /* ---------- acces la cos, cu o singura cerere la 800ms ---------- */

  var cartCache = null;
  var cartCacheAt = 0;
  var cartInFlight = null;
  var CART_TTL = 800;

  function getCart(force) {
    var now = Date.now();
    if (!force && cartCache && now - cartCacheAt < CART_TTL) {
      return Promise.resolve(cartCache);
    }
    if (cartInFlight) return cartInFlight;

    cartInFlight = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        // Shopify serveste /cart.js si ca text/javascript, deci nu ne luam
        // dupa content-type; incercam sa citim JSON si prindem esecul.
        return r.text().then(function (t) { return JSON.parse(t); });
      })
      .then(function (cart) {
        cartCache = cart;
        cartCacheAt = Date.now();
        return cart;
      })
      .catch(function () { return cartCache; })
      .then(function (cart) { cartInFlight = null; return cart; });

    return cartInFlight;
  }

  function inCart(cart, variantId) {
    if (!cart || !cart.items) return null;
    return cart.items.filter(function (i) {
      return String(i.variant_id) === String(variantId);
    })[0];
  }

  function addLine(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add.js ' + r.status);
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('change.js ' + r.status);
      return r.json();
    });
  }
  function onCartPage() {
    var el = document.querySelector('cart-items');
    return !!el && el.tagName.toLowerCase() === 'cart-items';
  }

  /**
   * Re-randeaza fie pagina de cos, fie sertarul, prin mecanismul temei.
   * Pe /cart tema are elementul <cart-items> cu propriul onCartUpdate;
   * in sertar cerem sectiunile si le trecem prin renderContents, exact ca
   * la o adaugare normala in cos.
   */
  function refresh() {
    cartCache = null;

    if (onCartPage()) {
      var items = document.querySelector('cart-items');
      if (items && typeof items.onCartUpdate === 'function') {
        try { items.onCartUpdate(); } catch (e) {}
      }
      return new Promise(function (resolve) {
        setTimeout(function () {
          getCart(true).then(function (cart) { sync(cart); resolve(cart); });
        }, 900);
      });
    }

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      return new Promise(function (resolve) {
        setTimeout(function () { getCart(true).then(resolve); }, 700);
      });
    }

    var ids;
    try {
      ids = drawer.getSectionsToRender().map(function (x) { return x.id; }).join(',');
    } catch (e) {
      ids = 'cart-drawer,cart-icon-bubble';
    }

    return fetch('/?sections=' + encodeURIComponent(ids), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try { drawer.renderContents({ sections: sections }); } catch (e) {}
        return new Promise(function (resolve) {
          setTimeout(function () {
            getCart(true).then(function (cart) { sync(cart); resolve(cart); });
          }, 500);
        });
      })
      .catch(function () { return getCart(true); });
  }


  /* ---------- ascunderea liniilor de serviciu din lista ---------- */

  function hideServiceLines(n) {
    serviceVariantIds(n).filter(Boolean).forEach(function (vid) {
      var inputs = document.querySelectorAll('[data-quantity-variant-id="' + vid + '"]');
      Array.prototype.forEach.call(inputs, function (input) {
        var row = input.closest('.cart-item') || input.closest('tr');
        if (row) row.classList.add('ct-line-hidden');
      });
    });
  }

  /**
   * Tema pune `is-empty` pe sertar la incarcarea paginii si o scoate doar cand
   * trece prin cart-items. Cand re-randam noi, o actualizam la fel ca ea,
   * altfel piciorul sertarului ramane ascuns desi cosul are produse.
   */
  function markEmptyState(cart) {
    var empty = !cart || cart.item_count === 0;
    ['cart-drawer', '#main-cart-footer', 'cart-drawer-items', '#CartDrawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.classList.toggle('is-empty', empty);
    });
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.classList.toggle('is-empty', empty);
  }

  /* ---------- aprobarea costului ---------- */

  function feeAcknowledged() {
    try { return window.localStorage.getItem(ACK_KEY) === '1'; } catch (e) { return false; }
  }

  function setFeeAcknowledged(on) {
    try { window.localStorage.setItem(ACK_KEY, on ? '1' : '0'); } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { _taxa_procesare: on ? 'aprobata de client' : '' } })
    }).catch(function () {});
  }

  /* ---------- sincronizare ---------- */

  function sync(cart) {
    if (!cart || !cart.items) return;
    var list = allNodes();
    if (!list.length) return;
    markEmptyState(cart);
    list.forEach(function (n) { syncOne(n, cart); });
    paintCheckoutTotal(cart);
    gateCheckout(list[0], cart);
  }

  function syncOne(n, cart) {

    var services = serviceVariantIds(n);
    var goods = cart.items.filter(function (i) {
      return services.indexOf(String(i.variant_id)) === -1;
    });

    n.root.hidden = goods.length === 0;
    hideServiceLines(n);

    if (goods.length === 0) {
      if (cart.items.length) dropOrphans(cart, services);
      return;
    }

    if (n.fee) {
      if (enforceFee(n, cart)) return;

      var feeLine = inCart(cart, n.fee.getAttribute('data-variant'));

      // Pretul afisat vine din cos, ca sa nu ramana in urma cand se schimba.
      if (feeLine) {
        var slot = n.fee.querySelector('[data-ct-fee-price]');
        if (slot && window.Shopify && window.Shopify.formatMoney) {
          slot.textContent = window.Shopify.formatMoney(feeLine.price, window.ctMoneyFormat || '{{amount_with_comma_separator}} lei');
        }
      }

      var ackNow = feeAcknowledged();
      if (ackNow && feeLine && !ackSynced && !(cart.attributes && cart.attributes._taxa_procesare)) {
        ackSynced = true;
        setFeeAcknowledged(true);
      }
      n.fee.classList.toggle('is-ack', ackNow);
      n.fee.classList.toggle('is-pending', !ackNow);
      var ackBox = n.fee.querySelector('[data-ct-fee-ok]');
      if (ackBox) ackBox.checked = ackNow;
    }

    if (n.upsell) {
      var added = !!inCart(cart, n.upsell.getAttribute('data-variant'));
      n.upsell.hidden = added;
    }

    n.addons.forEach(function (el) {
      var box = el.querySelector('input[type="checkbox"]');
      if (box) box.checked = !!inCart(cart, el.getAttribute('data-variant'));
    });

  }


  /**
   * Costul de procesare e obligatoriu: daca lipseste il punem la loc, iar
   * daca a ajuns pe mai multe linii sau cu cantitate mai mare de 1, corectam.
   * Rezultatul garantat: exact o linie, cu cantitatea 1.
   *
   * Nu renuntam niciodata sa il readaugam. Singura oprire e dupa mai multe
   * esecuri consecutive de retea, si si atunci doar temporar - urmatoarea
   * schimbare din cos reia incercarea.
   *
   * Intoarce true daca a pornit o corectie (deci starea afisata se
   * recalculeaza dupa ce se termina).
   */
  function enforceFee(n, cart) {
    if (locked()) return false;
    var feeVariant = n.fee.getAttribute('data-variant');
    var lines = cart.items.filter(function (i) {
      return String(i.variant_id) === String(feeVariant);
    });

    // Lipseste: o punem la loc. Nu renuntam niciodata definitiv - daca am
    // renunta, un client care sterge linia o data ar ramane fara ea pentru
    // tot restul vizitei. Doar rarim incercarile cand nu reusesc, ca sa nu
    // batem serverul degeaba.
    if (lines.length === 0) {
      var pauza = feeFails === 0 ? 0 : Math.min(2500 * feeFails, 15000);
      if (Date.now() - lastFeeTry < pauza) return false;

      lock();
      feeFails++;
      lastFeeTry = Date.now();

      addLine(feeVariant)
        .then(function () { feeFails = 0; })
        .then(refresh)
        .then(sync)
        .catch(function (e) {
          console.warn('[ct-extras] costul de procesare nu s-a putut adauga:', e && e.message);
        })
        .then(function () { busy = false; });
      return true;
    }

    // Linia exista: incercarile pornesc de la zero data viitoare.
    feeFails = 0;

    // A ajuns pe mai multe linii: le pastram doar pe prima.
    if (lines.length > 1) {
      lock();
      var extra = lines.slice(1);
      var chain = Promise.resolve();
      extra.forEach(function (line) {
        chain = chain.then(function () { return changeLine(line.key, 0); });
      });
      chain
        .then(refresh)
        .then(sync)
        .catch(function (e) { console.warn('[ct-extras] curatare duplicate esuata', e); })
        .then(function () { busy = false; });
      return true;
    }

    // Cantitate mai mare de 1: o aducem la 1.
    if (lines[0].quantity !== 1) {
      lock();
      changeLine(lines[0].key, 1)
        .then(refresh)
        .then(sync)
        .catch(function (e) { console.warn('[ct-extras] corectie cantitate esuata', e); })
        .then(function () { busy = false; });
      return true;
    }

    return false;
  }

  function dropOrphans(cart, serviceIds) {
    var orphan = cart.items.filter(function (i) {
      return serviceIds.indexOf(String(i.variant_id)) !== -1;
    })[0];
    if (!orphan || busy) return;
    lock();
    changeLine(orphan.key, 0)
      .then(refresh)
      .then(sync)
      .catch(function (e) { console.warn('[ct-extras] curatare esuata', e); })
      .then(function () { busy = false; });
  }

  function toggle(variantId, wanted, host) {
    if (locked()) return;
    lock();
    if (host) host.classList.add('is-busy');

    var work = wanted
      ? addLine(variantId)
      : getCart(true).then(function (cart) {
          var line = inCart(cart, variantId);
          return line ? changeLine(line.key, 0) : cart;
        });

    work
      .then(refresh)
      .then(sync)
      .catch(function (e) {
        console.warn('[ct-extras] operatie esuata', e);
        getCart(true).then(sync);
      })
      .then(function () {
        busy = false;
        if (host) host.classList.remove('is-busy');
      });
  }

  /* ---------- suma pe butonul de finalizare ---------- */

  function checkoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#CartDrawer-Checkout, .cart__checkout-button, #checkout')
    );
  }

  function paintCheckoutTotal(cart) {
    var price = document.querySelector('.totals .price-original, .totals__total-value');
    var text = price ? price.textContent.trim() : null;
    if (!text) return;
    checkoutButtons().forEach(function (btn) {
      var slot = btn.querySelector('.ct-total');
      if (!slot) {
        slot = document.createElement('span');
        slot.className = 'ct-total';
        btn.appendChild(slot);
      }
      slot.textContent = text;
    });
  }

  /**
   * Se poate trece la plata doar cu taxa in cos SI bifata. Bifa singura nu
   * ajunge: ramane tinuta minte in browser de la o vizita la alta, iar linia
   * de taxa poate lipsi (readaugare esuata, stearsa din alta fereastra).
   */
  function checkoutAllowed(n, cart) {
    if (!n || !n.fee) return true;
    return feeAcknowledged() && !!inCart(cart, n.fee.getAttribute('data-variant'));
  }

  function gateCheckout(n, cart) {
    var btns = checkoutButtons();
    if (!btns.length) return;
    var ok = checkoutAllowed(n, cart || cartCache);

    btns.forEach(function (btn) {
      btn.disabled = !ok;
      // Avertismentul e langa bifa, in blocul de cost. Al doilea, sub buton,
      // ar spune acelasi lucru de doua ori.
      var hint = btn.parentNode.querySelector('.ct-lock');
      if (hint) hint.remove();
    });
  }

  /* ---------- interactiuni ---------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-ct-add]');
    if (!btn || btn.disabled) return;
    var host = btn.closest('[data-ct-upsell]');
    if (!host) return;
    e.preventDefault();
    toggle(host.getAttribute('data-variant'), true, host);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;

    if (e.target.matches && e.target.matches('[data-ct-fee-ok]')) {
      var on = e.target.checked;
      setFeeAcknowledged(on);
      var fee = e.target.closest('[data-ct-fee]');
      if (fee) {
        fee.classList.toggle('is-ack', on);
        fee.classList.toggle('is-pending', !on);
      }
      var nf = nodes();
      if (nf) gateCheckout(nf, cartCache);
      return;
    }

    var host = e.target.closest('[data-ct-addon]');
    if (!host || e.target.type !== 'checkbox') return;
    toggle(host.getAttribute('data-variant'), e.target.checked, host);
  });

  /**
   * Plasa de siguranta pe trimiterea spre plata: daca butonul a ramas cumva
   * activ fara taxa (re-randare intre doua sincronizari), oprim plecarea,
   * readaugam taxa si aratam blocul de cost.
   */
  function isCheckoutSubmit(e) {
    var t = e.type === 'submit' ? e.submitter : (e.target.closest && e.target.closest('button, input'));
    return !!t && t.getAttribute('name') === 'checkout';
  }

  var guardPass = false;

  function blockCheckout(n) {
    var fee = n && n.fee;
    if (fee) {
      fee.classList.add('is-pending');
      if (fee.scrollIntoView) fee.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    resync();
  }

  /*
   * La click pe finalizare nu ne bazam pe cosul tinut minte in pagina, care
   * poate avea cateva secunde vechime: cerem cosul proaspat si abia apoi
   * lasam trimiterea sa plece.
   */
  function guardCheckout(e) {
    if (!booted || guardPass || !isCheckoutSubmit(e)) return;
    var n = nodes();
    if (!n || !n.fee) return;
    var btn = e.type === 'submit' ? e.submitter : e.target.closest('button, input');
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!checkoutAllowed(n, cartCache)) { blockCheckout(n); return; }
    getCart(true).then(function (cart) {
      if (!checkoutAllowed(n, cart)) { sync(cart); blockCheckout(n); return; }
      guardPass = true;
      try { btn.click(); } finally { setTimeout(function () { guardPass = false; }, 0); }
    });
  }

  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);

  /* ---------- pornire ---------- */

  var resyncTimer = null;

  function resync() {
    feeFails = 0;
    if (resyncTimer) clearTimeout(resyncTimer);
    resyncTimer = setTimeout(function () {
      resyncTimer = null;
      getCart(true).then(sync);
    }, 250);
  }

  var booted = false;

  function boot() {
    if (booted) return;
    booted = true;
    window.ctExtrasReady = true;

    // Tema emite eveniment doar la schimbarea cantitatii, nu si la adaugare.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && data.items) { cartCache = data; cartCacheAt = Date.now(); sync(data); }
        else resync();
      });
    }

    /*
     * Sertarul se re-randeaza fara sa anunte pe nimeni, asa ca il urmarim.
     * Observatorul sta DOAR pe sertar, nu pe toata pagina, si nu cere nimic
     * de la server singur: cere doar daca s-a schimbat ceva ce ne priveste,
     * si cel mult o data la 800ms prin cache-ul din getCart.
     */
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      var pending = null;
      var lastSignature = '';

      var observer = new MutationObserver(function () {
        var open = !!drawer && drawer.classList.contains('active');
        document.documentElement.classList.toggle('ct-drawer-open', open);
        toggleFloating(open);
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          // Semnatura starii: cate randuri sunt si daca sertarul e deschis.
          var sig = document.querySelectorAll('.cart-item').length + '|' +
                    (drawer.classList.contains('active') ? '1' : '0') + '|' +
                    document.querySelectorAll('[data-ct-extras]').length;
          if (sig === lastSignature) return;
          lastSignature = sig;
          getCart(true).then(sync);
        }, 300);
      });

      observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      var pageItems = document.querySelector('cart-items');
      if (pageItems && pageItems !== drawer) {
        observer.observe(pageItems, { childList: true, subtree: true });
      }
    }

    /*
     * Plasa de siguranta: la fiecare secunda comparam o semnatura a starii,
     * calculata doar din DOM. Daca nimic nu s-a schimbat, nu cerem nimic de
     * la server - deci costul e o comparatie de siruri, nu o cerere de retea.
     */
    var pulseSig = '';
    var pulseTick = 0;
    setInterval(function () {
      var d = document.querySelector('cart-drawer');
      var sig = document.querySelectorAll('.cart-item').length + '|' +
                (d && d.classList.contains('active') ? '1' : '0') + '|' +
                document.querySelectorAll('[data-ct-extras]').length + '|' +
                (document.querySelector('.totals .price-original') || {}).textContent;
      var schimbat = sig !== pulseSig;
      pulseSig = sig;

      // La fiecare a cincea bataie verificam si cosul de pe server, chiar daca
      // in pagina nu s-a miscat nimic: asa prindem costul scos din alta parte.
      pulseTick++;
      if (schimbat || pulseTick % 5 === 0) getCart(true).then(sync);
    }, 1000);
    resync();
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (root() || ++tries > 300) {
      clearInterval(timer);
      if (root()) boot();
    }
  }, 100);
})();
